import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useGetPatentInfoQuery } from "../../../api/agent";
import { Storage } from "../../../modules/Storage";
import { useAppDispatch } from "../../../store";
import { setAlertModal } from "../../../store/slice/modal";

const TABS = {
    PATENT: "patent",
    DESIGN: "design",
    TRADEMARK: "trademark",
};

const Contents = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLogin] = useState(Storage.get("accountKey") ? true : false);
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const role = Storage.get("role");
    const myAttorneyNo = Storage.get("agentNo");

    // tabs
    const [activeTab, setActiveTab] = useState(TABS.PATENT);

    // inputs per tab
    const [patentNo, setPatentNo] = useState("");
    const [designNo, setDesignNo] = useState("");
    const [trademarkNo, setTrademarkNo] = useState("");

    const [result, setResult] = useState(null);
    const [triggerNo, setTriggerNo] = useState(null);
    const { data, error, isFetching } = useGetPatentInfoQuery(
        { agentNo: myAttorneyNo, patentNo: patentNo, humanName: userName },
        { skip: !triggerNo }
    );
    useEffect(() => {
        if (!isLogin) {
            dispatch(
            setAlertModal({
                modalState: true,
                modalData: { title: "로그인이 필요합니다.", message: "로그인 페이지로 이동합니다." },
                callback: () => {
                navigate("/login");
                },
            })
            );
        } else {
            setUserName(Storage.get("humanName"));
            setEmail(Storage.get("accountKey"));
        }
    }, []);

    const handleSearch = async () => {
        if (!patentNo.trim()) setTriggerNo( { agentNo: myAttorneyNo, patentNo:"KIPRIS", humanName: userName });
        patentNo.replace(/-/g, "");
        setTriggerNo({ agentNo: myAttorneyNo, patentNo, humanName: userName });
    };


    return (
        <main style={{ minHeight: "800px", background: "#e5ecef" }}>
            <section>
            <Container className="container">
                <div className="row">
                    <div className="col-lg-3 col-12">
                        <UserInfo className="d-none d-lg-block">
                        <p className="user_name">{userName} 변리사</p>
                        <p className="user_email">{email}</p>
                        </UserInfo>

                        <MyPageMenu className="d-none d-lg-block">
                            <p className="title">마이페이지</p>
                            <ul>
                                <li>
                                <Link to={"/mypage"} className="active">
                                    매칭 정보
                                </Link>
                                </li>
                                <li>
                                <Link to={"/mypage/modify"}>회원정보 수정</Link>
                                </li>
                                <li>
                                <Link to={"/mypage/resumeModify"}>전문 정보 수정</Link>
                                </li>
                                <li>
                                <Link to="/mypage/patentInfo">
                                내 특허 정보 검색
                                </Link>
                                </li>
                                <li onClick={() => Storage.logout()}>
                                <Link>로그아웃</Link>
                                </li>
                            </ul>
                        </MyPageMenu>
                    </div>
                    <div className="col-lg-9 col-12 bg-white rounded shadow-sm">
                        <p className="fw-bold mb-2">상세 검색</p>
                        {/* tabs */}
                        <TabBar role="tablist" aria-label="검색 유형">
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.PATENT}
                                className={activeTab === TABS.PATENT ? "active" : ""}
                                onClick={() => setActiveTab(TABS.PATENT)}
                            >
                                특허/실용신안
                            </TabButton>
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.DESIGN}
                                className={activeTab === TABS.DESIGN ? "active" : ""}
                                onClick={() => setActiveTab(TABS.DESIGN)}
                            >
                                디자인
                            </TabButton>
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.TRADEMARK}
                                className={activeTab === TABS.TRADEMARK ? "active" : ""}
                                onClick={() => setActiveTab(TABS.TRADEMARK)}
                            >
                                상표
                            </TabButton>
                        </TabBar>
                        {activeTab === TABS.PATENT && (
                            <div role="tabpanel" aria-label="특허/실용신안">
                                <input
                                    type="text"
                                    placeholder="특허번호 입력"
                                    value={patentNo}
                                    onChange={(e) => {
                                        // 숫자만 허용
                                        const value = e.target.value.replace(/[^0-9]/g, "");
                                        setPatentNo(value);
                                    }}
                                    className="form-control mb-2" />
                                <button
                                    onClick={handleSearch}
                                    className="btn btn-primary w-100 mb-2">{patentNo == "" ? "내 기록 조회" : "특허 번호 조회"}</button>
                                {isFetching && <p>검색중...</p>}
                                {error && <p>오류가 발생했습니다. 다시 시도해주세요.</p>}
                                {data && (
                                    <div>
                                        <h3>검색 결과:</h3>
                                        {data.data?.length > 0 && patentNo == "" && data.data.map((item, index) => (
                                            <div key={index} style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                                                <p><strong>발명명:</strong> {item.inventionTitle}</p>
                                                <p><strong>출원인:</strong> {item.applicantName}</p>
                                                <p><strong>IPC 번호:</strong> {item.ipcNumber}</p>
                                                <p><strong>등록상태:</strong> {item.registerStatus}</p>
                                                <p><strong>요약:</strong> {item.astrtCont}</p>
                                                <p><strong>출원번호:</strong> {item.applicationNumber}</p>
                                                <p><strong>출원일자:</strong> {item.applicationDate}</p>
                                                <p><strong>공개번호:</strong> {item.openNumber}</p>
                                                <p><strong>공개일자:</strong> {item.openDate}</p>
                                                <p><strong>등록번호:</strong> {item.registerNumber}</p>
                                                <p><strong>등록일자:</strong> {item.registerDate}</p>
                                                <p><strong>공개일자:</strong> {item.publicationDate}</p>
                                                {item.bigDrawing && (
                                                    <div>
                                                        <strong>도면:</strong>
                                                        <br />
                                                        <img src={item.bigDrawing} alt="도면 이미지" style={{ maxWidth: "100%", height: "auto" }} />
                                                    </div>
                                                )}
                                                <br />
                                                
                                            </div>
                                        )
                                        )}
                                        {data.data.resultData && patentNo != "" && (
                                            <div style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                                                <p><strong>발명명:</strong> {data.data.resultData.inventTitle}</p>
                                                <p><strong>출원인:</strong> {data.data.resultData.invntrNm}</p>
                                                <p><strong>IPC 번호:</strong> {data.data.resultData.ipcNumber}</p>
                                                <p><strong>등록상태:</strong> {data.data.resultData.lstDspslNm}</p>
                                                <p><strong>출원번호:</strong> {data.data.resultData.applNo}</p>
                                                <p><strong>출원일자:</strong> {data.data.resultData.applDate}</p>
                                                <p><strong>공개번호:</strong> {data.data.resultData.openNo}</p>
                                                <p><strong>공개일자:</strong> {data.data.resultData.openDate}</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {!data && !isFetching && <p>검색 결과가 없습니다.</p>}
                            </div>
                        )}
                    </div>
                </div>
            </Container>
            </section>
        </main>
    );
}

const Container = styled.div`
padding: 40px 0;

@media (max-width: 991px) {
    padding: 40px 0;
}
`;

const UserInfo = styled.div`
position: relative;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: #fafbfe;
padding: 20px;

p.user_name {
    color: #070143;
    font-size: 25px;
    font-weight: 700;
    line-height: 1.2;
    padding: 3.4px 10px;
}
p.user_email {
    color: #687693;
    font-size: 15px;
    padding: 10px;
}
`;

const MyPageMenu = styled.div`
position: relative;
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
background-color: transparent;
margin-top: 65px;

p.title {
    color: #070143;
    font-size: 23px;
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 30px;
    width: 100%;

    &::before {
    position: absolute;
    width: 55px;
    height: 4px;
    left: 0;
    bottom: 0;
    background-color: #202d90;
    border-radius: 10px;
    content: "";
    }

    &::after {
    position: absolute;
    width: calc(80% - calc(var(--bs-gutter-x) * 0.5));
    height: 4px;
    left: 65px;
    bottom: 0;
    background-color: #f2f2f2;
    border-radius: 10px;
    content: "";
    }
}

ul {
    li {
    font-size: 19px;
    position: relative;

    & + li {
        margin-top: 12px;
    }

    a {
        color: #687693;
        display: block;
        width: 100%;
        transition: color 0.3s ease-in-out;

        &:hover {
        color: #1b267b;
        }

        &.active {
        color: #1b267b;
        }
    }
    }
}
`;

// simple styled tab bar
const TabBar = styled.div`
    display: inline-flex;
    gap: 8px;
    background: #f4f6fa;
    border-radius: 10px;
    padding: 6px;
    `;

const TabButton = styled.button`
    border: 0;
    background: transparent;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 14px;
    color: #495665;
    cursor: pointer;

    &.active {
        background: #ffffff;
        color: #1b267b;
        box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        font-weight: 600;
    }

    &:hover {
        color: #1b267b;
    }
`;

export default Contents;